module.exports = __webpack_public_path__ + "img/type-1.10a1262.png";